import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Mail from "@material-ui/icons/Mail";

const styles = (theme) => ({
  message: {
    fontSize: "20px",
    cursor: "pointer",
    color: theme.HeaderSelectedText,
  },
});

const Message = ({ classes, onClick }) => {
  return <Mail className={classes.message} onClick={onClick}></Mail>;
};

export default withStyles(styles)(Message);
